import React, { useState, useMemo } from 'react';
import { useViewportSize } from '@anton.bobrov/react-vevet-hooks';
import { objectKeys } from '@anton.bobrov/vevet-init';
import { ScrollView } from '@anton.bobrov/react-components';
import { useDebouncedEffect } from '@anton.bobrov/react-hooks';
import { useLsBoolState } from '../../../../utils/store/useLsBoolState.js';
import 'styled-components';
import '../../../../utils/styles/reset/resetBox.js';
import '../../../../utils/styles/reset/resetButton.js';
import '../../../../utils/styles/reset/resetInput.js';
import '../../../../utils/styles/reset/resetUl.js';
import { BaseRanges, ResponsiveRanges } from '../../../../utils/styles/responsive/responsive.js';
import '../../../../utils/styles/size/absoluteFullsize.js';
import { LayoutCtx } from './utils/context.js';

const Context = ({
  isScrollViewActive: isScrollViewActiveProp,
  isReady: isReadyProp,
  children
}) => {
  const [isScrollViewActive, setIsScrollViewActive] = useState(false);
  const [isReady, setIsReady] = useState(false);
  const [isRightMenuReadyToHide, setIsRightMenuReadyToHide] = useState(false);
  const [contentWidth, setContentWidth] = useState(0);
  const [isAsideMenuOpen, setIsAsideMenuOpen] = useLsBoolState(
    true,
    "aside_menu_open"
  );
  const [isRightMenuOpen, setIsRightMenuOpen] = useState(false);
  const [isModalMenuOpen, setIsModalMenuOpen] = useState(false);
  const [menuExpandedLinkCollection, setMenuExpandedLinkCollection] = useState(null);
  const { width } = useViewportSize();
  const breakpoint = useMemo(
    () => objectKeys(BaseRanges).find((key) => {
      const range = BaseRanges[key];
      return width >= range.min && width <= range.max;
    }),
    [width]
  );
  const responsiveBreakpoints = useMemo(
    () => objectKeys(ResponsiveRanges).filter((key) => {
      const range = ResponsiveRanges[key];
      return width >= range.min && width <= range.max;
    }),
    [width]
  );
  const value = useMemo(
    () => ({
      isReady,
      viewportWidth: width,
      breakpoint: breakpoint || "xs",
      responsiveBreakpoints,
      isAsideMenuOpen,
      setIsAsideMenuOpen,
      isRightMenuOpen,
      isRightMenuReadyToHide,
      setIsRightMenuReadyToHide,
      setIsRightMenuOpen,
      isModalMenuOpen,
      setIsModalMenuOpen,
      menuExpandedLinkCollection,
      setMenuExpandedLinkCollection,
      contentWidth,
      setContentWidth
    }),
    [
      isReady,
      width,
      breakpoint,
      responsiveBreakpoints,
      isAsideMenuOpen,
      setIsAsideMenuOpen,
      isRightMenuOpen,
      isRightMenuReadyToHide,
      setIsRightMenuReadyToHide,
      setIsRightMenuOpen,
      isModalMenuOpen,
      menuExpandedLinkCollection,
      contentWidth,
      setContentWidth
    ]
  );
  useDebouncedEffect(
    () => setIsScrollViewActive(isScrollViewActiveProp),
    [isScrollViewActiveProp],
    100
  );
  useDebouncedEffect(() => setIsReady(isReadyProp), [isReadyProp], 100);
  useDebouncedEffect(
    () => {
      if (!isRightMenuOpen) {
        setIsRightMenuReadyToHide(true);
      } else {
        setIsRightMenuReadyToHide(false);
      }
    },
    [isRightMenuOpen],
    800
  );
  useDebouncedEffect(
    () => {
      if (width <= 1024) {
        setIsModalMenuOpen(false);
        setIsAsideMenuOpen(false);
      }
    },
    [width],
    10
  );
  return /* @__PURE__ */ React.createElement(LayoutCtx.Provider, { value }, /* @__PURE__ */ React.createElement(ScrollView.Provider, { instanceKey: 0, isEnabled: isScrollViewActive }, children));
};
Context.displayName = "Layout.Context";

export { Context };
//# sourceMappingURL=index.js.map
